/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 캘린더 관련 API 호출 함수 모음
 * 버전 : 1.0
 * 파일명 : LoadArmyRecruit.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정일 : 2026-02-03, 축제 API 호출 함수 추가
 * ================================================================ */

import { getArmyRecruit, getArmyRecruitParams, getEventInfo } from 'src/api/Recruit';

export interface ArmyRecruit_SchduleType{
    course_name: string,
    start_date: string,
    end_date: string
}

export interface ArmyRecruitDataType{
    announce_id: number,
    title: string,
    recruitment_type: string,
    requirements: string,
    source_url: string,
    created_at: string,
    application_sdate: string,
    application_edate: string,
    status:string,
    schedules: ArmyRecruit_SchduleType[]
}

export const LoadArmyRecruit = async ({year,month,limit_cnt}:getArmyRecruitParams)=>{
    const response = await getArmyRecruit({year,month,limit_cnt})
    return {
        data: response.data as ArmyRecruitDataType[],
        totalPage: response.total_pages,
    };
    
}
export const LoadFestival = async ({year,month,limit_cnt}:getArmyRecruitParams)=>{
    const response = await getEventInfo({year,month})
    return {
        data: response.data as ArmyRecruitDataType[],
        totalPage: response.total_pages,
    };
}